import { render, staticRenderFns } from "./Task.vue?vue&type=template&id=ea4e595a&scoped=true"
import script from "./Task.vue?vue&type=script&lang=js"
export * from "./Task.vue?vue&type=script&lang=js"
import style0 from "./Task.vue?vue&type=style&index=0&id=ea4e595a&prod&scoped=true&lang=css"
import style1 from "./Task.vue?vue&type=style&index=1&id=ea4e595a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea4e595a",
  null
  
)

export default component.exports